import {API_BASE_URL, HEADERS} from "./config.ts";

interface ApiCallOptions extends RequestInit {
    data?: any;
    params?: Record<string, string | number | boolean>;
}

/**
 * Generic function to make API calls
 * @param
 */
export async function apiCall<T>(endpoint:string, options: ApiCallOptions = {}): Promise<T> {
    let url = `${API_BASE_URL}${endpoint}`;

    if (options.params){
        const queryParams = new URLSearchParams(options.params as Record<string, string>).toString();
        url += `?${queryParams}`;
    }

    const headers = {...HEADERS, ...options.headers};

    if (options.data && (options.method === 'POST' || options.method === 'PUT' || options.method === 'PATCH')) {
        options.body = JSON.stringify(options.data);
    }

    console.log('url', url);
    console.log('headers', headers);
    try{
        const response = await fetch(url, {
            ...options,
            headers,
        });

        if (!response.ok){
            let errorBody = null;
            try{
                errorBody = await response.json();
            }catch(jsonError){
                errorBody = await response.text();
            }

            const errorMessage = `API Error: ${response.status} ${response.statusText}. Details: ${
                typeof errorBody === 'string' ? errorBody : JSON.stringify(errorBody)
            }`;

            console.error(errorMessage);
            throw new Error(errorMessage);
        }

        if (response.status === 204){
            return null as T;
        }

        const contentType = response.headers.get('content-type');
        const contentLength = response.headers.get('content-length');
        
        // Handle empty response body
        if (contentLength === '0' || !contentType) {
            return null as T;
        }
        
        // Handle JSON responses
        if (contentType && contentType.includes('application/json')) {
            const text = await response.text();
            if (!text || text.trim() === '') {
                return null as T;
            }
            const parsed = JSON.parse(text);
            // If server explicitly returns null or undefined, respect it
            if (parsed === null || parsed === undefined) {
                return null as T;
            }
            return parsed as T;
        }

        return await response.json() as T;
    } catch (error){
        console.error('Unexpected error:', error);
        throw error;
    }
}